import React, { useState, useEffect } from "react";
import Header from "../../Components/Onboarding-Header/header";
import Sidebar from "../../Components/Onboarding.sidebar/onboarding-sidebar";
import {
  stepsCorporateShareholder,
  stepsTrustShareholder,
  stepsJointAccount,
} from "../../Constants/config";
import PersonalInfo from "./Steps/personal-info";
import ProofInfo from "./Steps/proof-info";
import LinkAccount from "./Steps/link-account";
import CashAccount from "./Steps/cash-account";
import UploadProof from "./Steps/upload-proof";
import ReviewSubmit from "./Steps/review-submit";
import CorporateInfo from "./Corporate-steps/corporate-info";
import DirectorInfo from "./Corporate-steps/directors-info";
import UploadProofCorporate from "./Corporate-steps/upload-proof-corporate";
import ReviewSubmitCorporate from "./Corporate-steps/review-submit-corporate";
import TrustInfo from "./Trust-steps/trust-info";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useToast } from "../../Utils/toastContext";
import {
  setStepStatusShareholder,
  setRejectedFieldsShareholder,
  clearStepStatusShareholder,
  clearCurrentStepShareholder,
  setCurrentStepShareholder,
} from "../../Redux/store/onboardingFormSlice";
import TrusteeInfo from "./Trust-steps/trustee-info";
import UploadProofTrust from "./Trust-steps/upload-proof-trust";
import ReviewSubmitTrust from "./Trust-steps/review-submit-trust";

const stepMapping = {
  PERSONAL_INFORMATION: 1,
  PROOF_ITS_YOU: 2,
  UPLOAD_PROOF_DOCS: 3,
  REVIEW_AND_SUBMIT: 4,
};
const stepMappingCorporate = {
  CORPORATE_INFORMATION: 1,
  DIRECTORS_SHAREHOLDERS: 2,
  UPLOAD_PROOF_DOCS: 3,
  REVIEW_AND_SUBMIT: 4,
};
const stepMappingTrust = {
  TRUST_INFORMATION: 1,
  TRUSTEES_BENEFICIARIES: 2,
  UPLOAD_PROOF_DOCS: 3,
  REVIEW_AND_SUBMIT: 4,
};
const MultiStepSidebarFormShareholder = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const dispatch = useDispatch();
  const { showToast } = useToast();
  const { shareholderId, shareholderType, userType } = useParams();
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();
  const currentStepRedux = useSelector(
    (state) => state.form.currentStepShareholder,
  );
  const [currentStep, setCurrentStep] = useState(Number(currentStepRedux));
  const [currentStepCorporate, setCurrentStepCorporate] = useState(
    Number(currentStepRedux),
  );
  const [currentStepTrust, setCurrentStepTrust] = useState(
    Number(currentStepRedux),
  );

  const renderStepContent = () => {
    dispatch(setCurrentStepShareholder(currentStep));
    switch (currentStep) {
      case 1:
        return (
          <PersonalInfo
            setCurrentStep={setCurrentStep}
            shareholderId={shareholderId}
          />
        );
      case 2:
        return (
          <ProofInfo
            setCurrentStep={setCurrentStep}
            shareholderId={shareholderId}
          />
        );
      case 3:
        return (
          <UploadProof
            setCurrentStep={setCurrentStep}
            shareholderId={shareholderId}
          />
        );
      case 4:
        return (
          <ReviewSubmit
            setCurrentStep={setCurrentStep}
            shareholderId={shareholderId}
          />
        );
      default:
        return <div>Step not found</div>;
    }
  };
  const renderStepContentCorporate = () => {
    dispatch(setCurrentStepShareholder(currentStepCorporate));
    switch (currentStepCorporate) {
      case 1:
        return <CorporateInfo setCurrentStep={setCurrentStepCorporate} />;
      case 2:
        return <DirectorInfo setCurrentStep={setCurrentStepCorporate} />;
      case 3:
        return (
          <UploadProofCorporate setCurrentStep={setCurrentStepCorporate} />
        );
      case 4:
        return (
          <ReviewSubmitCorporate setCurrentStep={setCurrentStepCorporate} />
        );
      default:
        return <div>Step not found</div>;
    }
  };
  const renderStepContentTrust = () => {
    dispatch(setCurrentStepShareholder(currentStepTrust));
    switch (currentStepTrust) {
      case 1:
        return <TrustInfo setCurrentStep={setCurrentStepTrust} />;
      case 2:
        return <TrusteeInfo setCurrentStep={setCurrentStepTrust} />;
      case 3:
        return <UploadProofTrust setCurrentStep={setCurrentStepTrust} />;
      case 4:
        return <ReviewSubmitTrust setCurrentStep={setCurrentStepTrust} />;
      default:
        return <div>Step not found</div>;
    }
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
          status: response.status,
        }));

        // Ensure errorData.message is extracted properly
        const errorMessage =
          typeof errorData === "object" && errorData.message
            ? errorData.message
            : `Error ${response.status}: ${response.statusText}`;

        throw new Error(errorMessage);
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later",
      );
    }
  };
  const getOnboardingStatus = async () => {
    try {
      const response = await GetAPIcalls(
        userType == "trustee"
          ? `/v1/onboarding/trust/corporate-trustees/sections/${shareholderId}`
          : `/v1/onboarding/stakeholder/status/${shareholderId}`,
      );
      if (response.status == 200) {
        if (response.data.onboarding_status.length > 0) {
          dispatch(setStepStatusShareholder(response.data.onboarding_status));

          // find first PENDING section
          let targetSection = response.data.onboarding_status.find(
            (item) => item.status === "PENDING" || item.status === "REJECTED",
          );

          // if no PENDING found, fallback to first DRAFT
          if (!targetSection) {
            targetSection = response.data.onboarding_status.find(
              (item) => item.status === "DRAFT",
            );
          }

          // if no PENDING found, fallback to Review
          if (!targetSection) {
            targetSection = response.data.onboarding_status[3];
          }
          if (shareholderType == 1) {
            if (targetSection && stepMapping[targetSection.section]) {
              const stepNumber = stepMapping[targetSection.section];
              setCurrentStep(stepNumber);
              dispatch(setCurrentStepShareholder(stepNumber));
            }
          }
          if (shareholderType == 2) {
            if (targetSection && stepMappingCorporate[targetSection.section]) {
              const stepNumber = stepMappingCorporate[targetSection.section];
              setCurrentStepCorporate(stepNumber);
              dispatch(setCurrentStepShareholder(stepNumber));
            }
          }
          if (shareholderType == 3) {
            if (targetSection && stepMappingTrust[targetSection.section]) {
              const stepNumber = stepMappingTrust[targetSection.section];
              setCurrentStepTrust(stepNumber);
              dispatch(setCurrentStepShareholder(stepNumber));
            }
          }
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      if (err.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
      }
      showToast(err.message, "error");
    } finally {
    }
  };
  const getRejectedField = async () => {
    try {
      const response = await GetAPIcalls(
        userType == "trustee"
          ? `/v1/onboarding/trust/corporate-trustees/rejected-fields/${shareholderId}`
          : `/v1/onboarding/stakeholder/rejected-fields/${shareholderId}`,
      );
      if (response.status == 200) {
        dispatch(setRejectedFieldsShareholder(response.data)); // <-- Save in Redux
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      if (err.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
      }
      showToast(err.message, "error");
    } finally {
    }
  };
  useEffect(() => {
    const loadAll = async () => {
      setIsLoading(true);
      try {
        await Promise.all([
          dispatch(clearStepStatusShareholder()),
          dispatch(clearCurrentStepShareholder()),
          getOnboardingStatus(),
          getRejectedField(),
        ]);
      } finally {
        setIsLoading(false);
      }
    };

    loadAll();
  }, [shareholderType, shareholderId, userType]);
  if (isLoading) {
    return (
      <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
        <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <Header
        setCurrentStep={
          shareholderType == 1
            ? setCurrentStep
            : shareholderType == 2
              ? setCurrentStepCorporate
              : setCurrentStepTrust
        }
      />

      {shareholderType == 1 && (
        <div className="flex  h-full flex-col md:flex-row w-full  mx-auto mt-6  overflow-hidden">
          <Sidebar
            steps={stepsJointAccount}
            currentStep={currentStep}
            shareholderType={true}
            setCurrentStep={setCurrentStep}
          />
          <main className="w-full md:w-3/4 md:px-2">{renderStepContent()}</main>
        </div>
      )}
      {shareholderType == 2 && (
        <div className="flex h-full flex-col md:flex-row w-full  mx-auto mt-6  overflow-hidden">
          <Sidebar
            steps={stepsCorporateShareholder}
            currentStep={currentStepCorporate}
            shareholderType={true}
            setCurrentStep={setCurrentStepCorporate}
          />
          <main className="w-full md:w-3/4 md:px-2">
            {renderStepContentCorporate()}
          </main>
        </div>
      )}
      {shareholderType == 3 && (
        <div className="flex h-full flex-col md:flex-row w-full  mx-auto mt-6  overflow-hidden">
          <Sidebar
            steps={stepsTrustShareholder}
            currentStep={currentStepTrust}
            shareholderType={true}
            setCurrentStep={setCurrentStepTrust}
          />
          <main className="w-full md:w-3/4 md:px-2">
            {renderStepContentTrust()}
          </main>
        </div>
      )}
    </div>
  );
};

export default MultiStepSidebarFormShareholder;
